export const SystemModules = {
  home: {
    id: 1,
    name: 'Home',
    uri: 'home'
  },
  erp: {
    id: 2,
    name: 'ERP',
    uri: 'erp'
  },
  external: {
    id: 3,
    name: 'Externo',
    uri: 'externo'
  },
}